import React from "react";
import { Mail, Phone, MapPin, Clock, CalendarDays, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const contactMethods = [{
  id: "email",
  icon: Mail,
  title: "Email Criptata",
  value: "intel@russeo.ru",
  subtext: "Canale sicuro PGP per dossier tecnici",
  link: "mailto:intel@russeo.ru",
  hasStatus: true
}, {
  id: "phone",
  icon: Phone,
  title: "Linea Diretta",
  value: "+7 (495) 000-0000",
  subtext: "Supporto operativo Mosca (MSK)",
  link: "tel:+74950000000",
  hasStatus: false
}, {
  id: "location",
  icon: MapPin,
  title: "Headquarters",
  value: "Presnenskaya Nab. 12",
  subtext: "Federation Tower, Moscow City",
  link: "#",
  hasStatus: false
}];
const officeHours = [{
  day: "Lunedì - Venerdì",
  time: "09:00 - 19:00 MSK"
}, {
  day: "Sabato",
  time: "10:00 - 15:00 MSK"
}, {
  day: "Domenica",
  time: "Monitoraggio Remoto"
}];
export default function LetsTalkLearning() {
  return <section data-section-id="228603" id="i-nostri-hub-operativi" className="bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/grid_mesh_pattern.png')] bg-center [mask-image:radial-gradient(white,transparent)]"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-12 max-w-3xl md:mb-16">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl uppercase">
            I Nostri Hub Operativi
          </h2>
          <p className="text-muted-foreground font-sans text-lg md:text-xl leading-relaxed">
            Presenza fisica nei nodi nevralgici della RuNet. Coordiniamo le operazioni di SEO e Lead Generation dai nostri centri di intelligence a Mosca e San Pietroburgo.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          {}
          <div className="lg:col-span-5">
            <Card className="bg-card/50 border-border/50 shadow-2xl h-full rounded-none backdrop-blur-md border-l-2 border-l-primary">
              <CardHeader className="pb-4">
                <div className="bg-secondary/10 text-secondary mb-4 inline-flex h-12 w-12 items-center justify-center rounded-none border border-secondary/30">
                  <Clock className="h-6 w-6" />
                </div>
                <CardTitle className="font-default text-2xl text-foreground uppercase tracking-tight">Orari Operativi</CardTitle>
                <CardDescription className="font-sans text-base text-muted-foreground">
                  Sincronizzazione con i mercati CSI e finestre di aggiornamento algoritmi.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-4">
                  {officeHours.map((schedule, i) => <li key={i} data-index={i} className="flex items-center justify-between border-b border-border/20 pb-4 last:border-0 last:pb-0">
                      <span className="font-sans text-foreground font-medium flex items-center gap-2">
                        <CalendarDays className="text-secondary h-4 w-4" />
                        {schedule.day}
                      </span>
                      <span className="font-mono text-sm text-muted-foreground">
                        {schedule.time}
                      </span>
                    </li>)}
                </ul>
                
                <div className="mt-8 pt-6 border-t border-border/20">
                  <p className="font-sans text-sm text-muted-foreground mb-4 italic">
                    Protocolli di emergenza attivi 24/7 per incidenti di conformità FZ-152.
                  </p>
                  <Button asChild className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground rounded-none font-bold uppercase tracking-wider">
                    <Link to="/ContactPage">
                      Richiedi Accesso
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 h-full">
              {contactMethods.map((method, i) => <Card key={method.id} data-index={i} className={`flex flex-col rounded-none border-border/40 bg-card/30 shadow-sm transition-all duration-300 hover:border-secondary/50 hover:bg-card/50 ${i === 2 ? "sm:col-span-2" : ""}`}>
                  <CardHeader>
                    <div className="flex items-start justify-between">
                      <div className="bg-muted text-secondary inline-flex h-10 w-10 items-center justify-center rounded-none border border-border">
                        <method.icon className="h-5 w-5" />
                      </div>
                      {method.hasStatus && <div className="flex items-center gap-2 rounded-none bg-secondary/10 px-2.5 py-1 border border-secondary/20">
                          <span className="relative flex h-2 w-2">
                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary opacity-75"></span>
                            <span className="relative inline-flex h-2 w-2 rounded-full bg-secondary"></span>
                          </span>
                          <span className="font-mono text-[10px] font-bold text-secondary uppercase tracking-widest">
                            Live Link
                          </span>
                        </div>}
                    </div>
                    <CardTitle className="font-default mt-4 text-lg uppercase tracking-tight text-foreground">
                      {method.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-1">
                    <Link to={method.link} className="text-foreground hover:text-secondary font-mono text-lg font-medium transition-colors break-all">
                      {method.value}
                    </Link>
                    <p className="text-muted-foreground font-sans mt-1 text-sm">
                      {method.subtext}
                    </p>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}